<div
    [ngStyle]="{ width: '15vw' }"
    class="progress-container height-15"
>
    <div
        [ngStyle]="{ width: computedValue + '%', 'min-width': minWidth + 'px', 'max-width': '100%' }"
        class="progress h-100"
    ></div>
</div>
